import React from 'react';
import '../assets/css/App.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Homepage from './component/page/Homepage';

export default function App() {
  return (
    <div className="App">
      <Homepage />
    </div>
  );
}